import { AdvisorsLayout, HomeSection } from '@src/components/sco/Advisors'
import {
  ADVISORS_LANDING_DESCRIPTION,
  ADVISORS_LANDING_TITLE,
  advisorsLandingSeo,
} from '@src/components/sco/Advisors/utils/advisorsSeo'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { usePageSEO } from '@src/hooks/usePageSEO'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'

export { getServerSideProps } from '@src/lib/server-side-rendering'

/**
 * SEO defaults for the public /advisors entry (guest marketing + logged-in hub).
 * Guests see the marketing landing (`AdvisorsLandingSection`); logged-in users see the product hub.
 * `/advisors/landing` always renders that landing. `/advisors/v2` 301s here (`next.config.ts`).
 */
export default function Page() {
  const activeContent = useActiveContentContext()

  useUniversalEffect(() => {
    activeContent.setSiteSection('advisors.landing')
    activeContent.setItem({
      __typename: 'LandingPage',
      title: ADVISORS_LANDING_TITLE,
      description: ADVISORS_LANDING_DESCRIPTION,
    })
    return () => activeContent.setItem(null)
  }, [])
  usePageSEO(advisorsLandingSeo())

  return (
    <AdvisorsLayout showAside>
      <HomeSection />
    </AdvisorsLayout>
  )
}
